import * as React from 'react';
import { Checkbox, Container, Form } from 'semantic-ui-react';
import * as InfoCardApi from '~/Api/InfoCard';
export var Switcher = function (_a) {
    var details = _a.details, index = _a.index, setIndex = _a.setIndex;
    return details.length > 1 ? (<Container fluid data-testid='switcher'>
			<Form>
				{details.map(function (detail, i) { return (<Form.Field key={detail.title}>
						<Checkbox radio checked={index === details.indexOf(detail)} data-testid={"checkbox-".concat(i)} label={"".concat(detail.title, " ").concat(detail.units !== undefined && detail.units.type === 'currency'
                ? "(".concat(InfoCardApi.Currency[detail.units.code], ")")
                : '')} onClick={function () {
                setIndex(details.indexOf(detail));
            }}/>
					</Form.Field>); })}
			</Form>
		</Container>) : null;
};
